import { Box, Dialog, Typography } from '@mui/material'
import React, { useContext } from 'react'
import { ApplicationContext } from '../../context/application_ctx'
import { font } from '../../styles/font';
import { theme } from '../../styles/theme';
import { ModuleType } from '../../constants';
import { LicenceTickIcon } from '../../svgIcons/icons';
import { ButtonCustom } from '../button';
import { useNavigate } from 'react-router-dom';

export default function WelcomeDialog() {
    // context
    const navigate = useNavigate()
    const { isOpenWelcomeDialog, setIsOpenWelcomeDialog, setActiveTab, } = useContext(ApplicationContext);


    // const [epId, setEpId] = useState("")

    function handleCloseRegisterDialog() {
        setIsOpenWelcomeDialog(false);
    }

    function handleContine() {
        handleCloseRegisterDialog();
        setActiveTab(ModuleType?.licence);
        navigate('/licence')
        setIsOpenWelcomeDialog(false); // close the welcome dialog after first time showing to user
    }


   
let steps = [{label:'Choose a plan'},{label:'Onboard your employees'},{label:'Download the app'},{label:'Manage access and impact'}]
    return (
        <Dialog open={isOpenWelcomeDialog}
            sx={{
                "& .MuiDialog-paper": {
                    minWidth: "36vw",
                    minHeight: "60vh"
                },
            }}
        >
            <Box p={4} display="flex" flexDirection="column" alignItems="center" gap={2}>

                {/* <Box
                    display={"flex"}
                    width="94px"
                    justifyContent="center"
                    height="60px"
                >
                    <img
                        width={"100%"}
                        height="100%"
                        src={require("../../assets/images/logo.png")}
                        alt="Mindamigo"
                    />
                </Box> */}

                <Box display="flex" flexDirection="column" alignItems="center"  >
                <Box display="flex" gap='8px' alignItems="center"  >
                <Typography fontSize={font.size.fs_2} color={theme.col_2} fontFamily={font.family.fm_2} fontWeight='bold'>Welcome</Typography>
                    <Typography fontSize={font.size.fs_2} color={theme.col_3} fontFamily={font.family.fm_2} fontWeight='bold'>to</Typography>

                </Box>

                    <Box
                    display={"flex"}
                    width="304px"
                    justifyContent="center"
                    height="60px"
                >
                    <img
                        width={"100%"}
                        height="100%"
                        src={require("../../assets/images/mindamigo-logo.png")}
                        alt="Mindamigo"
                    />
                </Box>
                </Box>
                    <Typography fontSize={font.size.fs_3} color={theme.col_11} fontFamily={font.family.fm_2} fontWeight='bold'>Start your holistic journey to better mental health</Typography>

                <Box p={2} width="70%" display="flex" flexDirection="column" alignItems="center" justifyContent="flex-start" gap={1} >
                    {steps.map((data)=>
                    <Box p={1} display="flex" alignItems="center" gap={2} width="100%">
                        <LicenceTickIcon color={theme.col_2} />
                        <Typography variant="body1" color={theme.col_9} fontWeight={600}>{data.label}</Typography>
                    </Box>
                    )}
                   
                </Box>
                <ButtonCustom
                      onClick={handleContine}
                    //   fullWidth={true}
                    //   disabled={loaderStateApi}
                    //   loaderState={loaderStateApi}
                    width='288px'
                      borderRadius="42px"
                      size="large"
                      background={theme.col_2}
                      backgroundRipple={theme.col_3}
                      focusColor={theme.col_1}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      typography={
                        <Typography
                          fontFamily={font.family.fm_2}
                          textTransform={"capitalize"}
                          fontSize={font.size.fs_3}
                          fontWeight="bold"
                          color={theme.col_4}
                        >
                          Continue
                        </Typography>
                      }
                    />

                {/* <ButtonMA size="large" onClick={() => handleContine()} sx={{ width: "288px" }}>
                    Continue
                </ButtonMA> */}
            </Box>
        </Dialog>
    )
}
